import React from 'react';

import type { TProfessional } from 'types/appointment';

import { PlayfulTeamMember } from './PlayfulTeamMember';

import s1 from 'themes/playful/components/PlayfulLayout.module.css';

type TProps = {
  onProfessionaClick: (professional: TProfessional) => void;
  professionals: TProfessional[];
};

export const PlayfulTeamList = ({
  professionals = [],
  onProfessionaClick,
}: TProps) => (
  <div className={s1.content}>
    {professionals.map((member) => (
      <PlayfulTeamMember
        key={member.guid}
        professional={member}
        onClick={onProfessionaClick}
      />
    ))}
  </div>
);
